import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css";
import keycloak from "./keycloak";
import reportWebVitals from "./reportWebVitals";

keycloak
  .init({ onLoad: "check-sso", idpHint: "govbr" })
  .then((authenticated) => {
    if (authenticated) {
      setInterval(() => {
        keycloak.updateToken(60).catch(() => {
          sessionStorage.removeItem("representacao-cgibs");
          keycloak.logout();
        });
      }, 6000);
    } else {
      //keycloak.login();
    }
    const root = ReactDOM.createRoot(document.getElementById("root"));
    root.render(
      <React.StrictMode>
        <App keycloak={keycloak} />
      </React.StrictMode>
    );
  })
  .catch((error) => {
    console.error("Erro ao inicializar Keycloak", error);
  });

keycloak.onAuthSuccess = () => {
  console.log("Login efetuado com sucesso");
  sessionStorage.setItem("logar-cgibs", "true"); 
};

keycloak.onTokenExpired = () => {
  console.log("Access token expired. Attempting to refresh...");
  keycloak
    .updateToken(30) // Attempt to refresh token, ensuring it's valid for at least 30 seconds
    .then((refreshed) => {
      if (refreshed) {
        console.log("Token successfully refreshed.");
      } else {
        console.log(
          "Token not refreshed, but is still valid for a short period."
        );
      }
    })
    .catch((error) => {
      console.error("Failed to refresh token:", error); 
    });
};

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
